"use client";

import { useEffect } from "react";

const JobDetailDataLayer = ({ job }) => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "ecommerce",
      eventCategory: "ecommerce",
      eventAction: "job detail",
      ecommerce: {
        detail: {
          products: [
            {
              name: job.title,
              id: job.id,
              price: "10",
              brand: job.office_id,
              category: job.sector_group,
            },
          ],
        },
      },
      location: job.city,
      workregime: job.regime,
      contract: job.type,
      speciality: job.specialty,
      creationdate: new Date(job.created_at)
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(",", ""),
    });
  }, [job]);

  return null; // Render nothing
};

export default JobDetailDataLayer;
